import { UserPreview } from '@main/access-control-types';
import type { SchemaToType } from '@main/schema-utils';
import { mkInput, mkType } from '@main/schema-utils';

export const AssessmentGroupTriggerConfiguration = mkType({
  name: 'AssessmentGroupTriggerConfiguration',
  comment:
    'Default values, at the group level, for setting the configuration of the form triggers',
  fields: {
    id: {
      comment: `The id of the trigger configuration.`,
      type: 'id',
      modelName: 'assessmentGroupTriggerConfiguration',
    },
    assessmentTriggerId: {
      comment: `The id of the parent template's assessment trigger.`,
      type: 'id',
      modelName: 'assessmentTrigger',
    },
    assignees: {
      comment: `The users assigned to the trigger's secondary form`,
      type: UserPreview,
      list: true,
    },
    externalAssigneeEmails: {
      comment: `The emails of the external users assigned to the trigger's secondary form`,
      type: 'string',
      list: true,
    },
  },
});

/** Override type */
export type AssessmentGroupTriggerConfiguration = SchemaToType<
  typeof AssessmentGroupTriggerConfiguration
>;

export const AssessmentFormTriggerInput = mkInput({
  name: 'AssessmentFormTriggerInput',
  comment:
    'Input for setting the configuration of assessment triggers for a form or group',
  fields: {
    assessmentTriggerId:
      AssessmentGroupTriggerConfiguration.fields.assessmentTriggerId,
    assigneeIds: {
      comment: `The IDs of the users to assign to the trigger's secondary form`,
      type: 'id',
      modelName: 'user',
      list: true,
      optional: true,
    },
    externalAssigneeEmails: {
      ...AssessmentGroupTriggerConfiguration.fields.externalAssigneeEmails,
      comment: `The emails of the external users to assign to the trigger's secondary form`,
      optional: true,
    },
  },
});

/** Override type */
export type AssessmentFormTriggerInput = SchemaToType<
  typeof AssessmentFormTriggerInput
>;
